import React, { useRef, useState, useEffect } from 'react'
import styled from 'styled-components'

import TextInput, { TextInputProps } from 'components/TextInput'
import { Icon } from 'components'
import AddonIcon from 'components/TextInput/AddonIcon'
import useOnClickOutside from 'hooks/use-click-outside-hooks'

type SearchBarProps = {
  onClose: () => void
  onSearch: () => void
}

const SearchBar = (props: TextInputProps & SearchBarProps) => {
  const { onClose, onSearch, ...restProps } = props
  const [isCollapsed, setIsCollapsed] = useState<boolean>(false)
  const searchInputRef = useRef<HTMLInputElement>(null)
  const addOnIconRef = useRef<HTMLInputElement>(null)

  useOnClickOutside(searchInputRef, () => {
    if (addOnIconRef.current) {
      addOnIconRef.current.style.border = 'none'
    }
  })

  useEffect(() => {
    if (isCollapsed) {
      searchInputRef.current?.focus()
      if (searchInputRef.current) searchInputRef.current.style.borderRight = 'none'
      if (addOnIconRef.current) {
        const childDiv = addOnIconRef.current.querySelector('div')
        if (childDiv) {
          childDiv.style.border = 'none'
        }
        addOnIconRef.current.style.borderTopRightRadius = '4px'
        addOnIconRef.current.style.borderBottomRightRadius = '4px'
        addOnIconRef.current.style.border = '1px solid #3366FF'
        addOnIconRef.current.style.borderLeft = 'none'
      }
    }
  }, [isCollapsed])

  const handleClickIcon = () => {
    setIsCollapsed(!isCollapsed)
    !isCollapsed && onClose()
  }

  const handleClearClick = (e?: React.MouseEvent<HTMLButtonElement>) => {
    e?.stopPropagation()
    setIsCollapsed(!isCollapsed)
    onClose()
  }

  const handleSearch = (e?: React.MouseEvent<HTMLElement>) => {
    e?.stopPropagation()
    if (isCollapsed && searchInputRef.current?.value) {
      onSearch()
      return
    }
  }

  return (
    <SearchContainer>
      <TextInputWrapper isCollapsed={isCollapsed}>
        <TextInput
          ref={searchInputRef}
          customIcon={
            isCollapsed ? <Icon fontSize={14} icon={['far', 'times']} onClick={handleClearClick} /> : undefined
          }
          variant={isCollapsed ? 'simple' : 'boxless'}
          icon={!isCollapsed ? ['far', 'search'] : undefined}
          iconColor="gray5"
          placeholder={isCollapsed ? 'search_lbl' : ''}
          onClickIcon={handleClickIcon}
          hideInput={!isCollapsed}
          width={isCollapsed ? 430 : 50}
          height={40}
          fill="white"
          iconPosition="right"
          addonAfter={
            isCollapsed ? (
              <AddOnWrapper ref={addOnIconRef}>
                <AddonIcon
                  disabled={props.value ? false : true}
                  position="after"
                  icon={['far', 'search']}
                  onClick={handleSearch}
                  {...(props.value && {
                    bg: 'blue1',
                    color: 'white',
                  })}
                />
              </AddOnWrapper>
            ) : null
          }
          {...restProps}
        />
      </TextInputWrapper>
    </SearchContainer>
  )
}

const SearchContainer = styled.div`
  position: relative;
  width: 50px;
  overflow: visible;
`

const TextInputWrapper = styled.div<{ isCollapsed?: boolean }>`
  position: relative;
  left: ${(p) => (p.isCollapsed ? '-380px' : '0')};
`

const AddOnWrapper = styled.div`
  height: 40px;
`

export default SearchBar
